import { FieldDesignChange } from '../../../../../FDCTrackerContext/types'
import { toLabeledValues } from 'components/CIMSSelect/utils/labeledValues'

export function toDisciplineValues(
  disciplines: FieldDesignChange['disciplines'] | undefined
) {
  if (!disciplines) return []
  return toLabeledValues(disciplines, {
    label: 'name',
    value: 'id',
    tooltip: 'description',
    deleted: ({ deleted }) => deleted,
  })
}
